(function () {
  'use strict';
  if (window.__pkCartMonogram) return;
  window.__pkCartMonogram = true;

  function nudgeOf(el) {
    return el && el.closest ? el.closest('[data-pk-mono-nudge]') : null;
  }

  function toggle(box) {
    var form = box.querySelector('[data-pk-mono-form]');
    var open = form.hidden;
    form.hidden = !open;
    box.classList.toggle('is-open', open);
    box.querySelector('[data-pk-mono-open]').setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) box.querySelector('[data-pk-mono-name]').focus();
  }

  function fail(box, button, message) {
    var error = box.querySelector('[data-pk-mono-error]');
    error.textContent = message;
    error.hidden = false;
    button.disabled = false;
    button.textContent = 'Add';
  }

  function add(box) {
    var input = box.querySelector('[data-pk-mono-name]');
    var button = box.querySelector('[data-pk-mono-add]');
    var name = input.value.trim();
    if (!name) {
      fail(box, button, 'Please enter a first name (1–12 characters).');
      input.focus();
      return;
    }
    box.querySelector('[data-pk-mono-error]').hidden = true;
    button.disabled = true;
    button.textContent = 'Adding…';

    var drawer = box.closest('cart-drawer');
    var body = {
      items: [
        {
          id: parseInt(box.getAttribute('data-fee'), 10),
          quantity: 1,
          properties: { 'Monogram Name': name, 'Monogram for': box.getAttribute('data-for') }
        }
      ]
    };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add the monogram.');
          return data;
        });
      })
      .then(function (data) {
        if (drawer) {
          // The drawer's renderer expects the single-item shape at the top.
          if (data.items && data.items[0]) {
            data.key = data.key || data.items[0].key;
            data.id = data.id || data.items[0].id;
          }
          drawer.renderContents(data);
          return;
        }
        /* Cart page: reload so the lines, totals and checkout bar all agree.
           Mark this cart as already celebrated so the confetti stays put. */
        return fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            try {
              sessionStorage.setItem('pk-cart-confetti', cart.item_count + '-' + cart.total_price);
            } catch (e) {}
            window.location.reload();
          });
      })
      .catch(function (err) {
        fail(box, button, err.message || 'Could not add the monogram. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var box = nudgeOf(e.target);
    if (!box) return;
    if (e.target.closest('[data-pk-mono-open]')) {
      e.preventDefault();
      toggle(box);
    } else if (e.target.closest('[data-pk-mono-add]')) {
      e.preventDefault();
      add(box);
    }
  });

  /* Capture phase, stopped there: the field sits inside the cart's form, whose
     quantity checker would otherwise read each keystroke as a quantity change.
     Enter adds the name instead of submitting the cart. */
  function capture(e) {
    var box = nudgeOf(e.target);
    if (!box) return;
    e.stopPropagation();
    if (e.type === 'input') box.querySelector('[data-pk-mono-error]').hidden = true;
  }
  document.addEventListener('change', capture, true);
  document.addEventListener('input', capture, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-pk-mono-name]')) return;
    e.preventDefault();
    add(nudgeOf(e.target));
  }, true);
})();
